(function () {
  var isBackForward = function () {
    try {
      var nav = window.performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return !!window.performance.navigation && window.performance.navigation.type === 2;
    } catch (error) {
      return false;
    }
  };

  var cameFromDetail = function (detailPaths) {
    try {
      if (!document.referrer) return false;
      var ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return false;
      return detailPaths.indexOf(ref.pathname) !== -1;
    } catch (error) {
      return false;
    }
  };

  var ENTRY_KEY = '__awReturnListTokens';
  var entryToken = function (key) {
    try {
      var existing = window.history.state;
      var state = existing && typeof existing === 'object' ? existing : {};
      var tokens = state[ENTRY_KEY] && typeof state[ENTRY_KEY] === 'object' ? state[ENTRY_KEY] : {};
      if (tokens[key]) return tokens[key];
      var token = String(Date.now()) + '-' + String(Math.random()).slice(2);
      var newTokens = {};
      Object.keys(tokens).forEach(function (name) { newTokens[name] = tokens[name]; });
      newTokens[key] = token;
      var newState = {};
      Object.keys(state).forEach(function (name) { newState[name] = state[name]; });
      newState[ENTRY_KEY] = newTokens;
      window.history.replaceState(newState, '');
      return token;
    } catch (error) { return null; }
  };
  var sameEntry = function (key, saved) {
    return !!(saved && saved.entryToken && saved.entryToken === entryToken(key));
  };
  var restoreScroll = function (value) {
    var y = Number(value);
    if (!Number.isFinite(y) || y <= 0) return;
    var cancelled = false;
    var cancel = function () { cancelled = true; };
    window.addEventListener('touchstart', cancel, { passive: true });
    window.addEventListener('wheel', cancel, { passive: true });
    var apply = function () {
      if (cancelled) return;
      var html = document.documentElement;
      var before = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      html.style.scrollBehavior = before;
    };
    window.requestAnimationFrame(apply);
    window.setTimeout(apply, 100);
    window.setTimeout(apply, 350);
    window.setTimeout(function () {
      window.removeEventListener('touchstart', cancel);
      window.removeEventListener('wheel', cancel);
    }, 450);
  };

  var read = function (key) {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  var write = function (key, state) {
    try {
      var data = {};
      Object.keys(state).forEach(function (name) {
        data[name] = state[name];
      });
      data.y = Math.round(window.pageYOffset || 0);
      data.entryToken = entryToken(key);
      window.sessionStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      return;
    }
  };

  window.awListState = {
    detailPaths: function (cards) {
      var paths = [];
      cards.forEach(function (card) {
        var links = card.matches('a[href]') ? [card] : [];
        Array.prototype.forEach.call(card.querySelectorAll('a[href]'), function (link) {
          links.push(link);
        });
        links.forEach(function (link) {
          try {
            var url = new URL(link.getAttribute('href'), window.location.href);
            if (url.origin === window.location.origin && paths.indexOf(url.pathname) === -1) paths.push(url.pathname);
          } catch (error) {
            return;
          }
        });
      });
      return paths;
    },

    claimScroll: function (key) {
      var saved = read(key);
      if (saved && (isBackForward() || sameEntry(key, saved)) && 'scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    },

    load: function (key, detailPaths) {
      var saved = read(key);
      var backForward = isBackForward();
      if (!saved || !(backForward || sameEntry(key, saved) || cameFromDetail(detailPaths))) return null;
      return { state: saved, backForward: backForward };
    },

    write: write,
    restoreCached: function (key, scope) {
      var saved = read(key);
      if (saved && saved.scope === scope && sameEntry(key, saved)) {
        restoreScroll(saved.y);
      }
    },

    finish: function (loaded) {
      if (loaded) restoreScroll(loaded.state.y);
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
    }
  };
})();
